import { render, staticRenderFns } from "./FacSettings.vue?vue&type=template&id=4a4add8e"
import script from "./FacSettings.vue?vue&type=script&lang=js"
export * from "./FacSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports